export const SET_LOADING_DATA = '@productKit/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@productKit/SET_LOADING_SEND';

//LIST
export const GET_ALL_REQUEST = '@productKit/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@productKit/GET_ALL_SUCCESS';

export const DELETE_ITEM = '@productKit/DELETE_ITEM';
export const EDIT_ITEM = '@productKit/EDIT_ITEM';

export const SEARCH = '@productKit/SEARCH';

export const SET_PAGE = '@productKit/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@productKit/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@productKit/SET_ORDER';
export const SET_ORDERBY = '@productKit/SET_ORDEBY';

//FORM
export const GET_BY_ID_REQUEST = '@productKit/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@productKit/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@productKit/SAVE_REQUEST';
export const SAVE_SUCCESS = '@productKit/SAVE_SUCCESS';

export const UPDATE_FIELD = '@productKit/UPDATE_FIELD';


export const GET_FILTER_PRODUCT_REQUEST = '@productKit/GET_FILTER_PRODUCT_REQUEST';
export const GET_FILTER_PRODUCT_SUCCESS = '@productKit/GET_FILTER_PRODUCT_SUCCESS';

